<template>
	<div class="container">
		<!-- 面包屑导航 -->
		<div>
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item class="mybread" :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item class="mybread">管理员权限</el-breadcrumb-item>
				<el-breadcrumb-item class="mybread">用户管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<!-- 第一行搜索框和新增按钮 -->
		<el-row type="flex" align="middle" class="myRow">
			<el-col :span="2">用户搜索</el-col>
			<el-col :span="7">
				<el-input placeholder="请输入姓名" v-model="queryInfo.fullName" clearable>
					<el-button slot="append" icon="el-icon-search" @click="mygetUserList()"></el-button>
				</el-input>
			</el-col>
			<el-col :span="2"></el-col>
			<div class="exportExcel">
				<download-excel class="export-excel-wrapper" :data="userList" :fields="json_fields" :header="title"
					name="用户信息表.xls">
					<el-button type="primary" size="small"><i class="el-icon-upload2"></i>导出数据</el-button>
				</download-excel>
			</div>
		</el-row>


		<!-- 用户列表-->
		<el-table border height="650px" :data="userList" :header-cell-style="{
			background: '#fff1f0', height: '60px', color: '#000000'
		}">
			<el-table-column type="index" label="序号" width="50px"> </el-table-column>
			<el-table-column label="操作" width="150px">
				<template slot-scope="scope">
					<el-tooltip content="修改用户角色" placement="top" popper-class="tooltip">
						<el-popover :ref="`popover-${scope.$index}`" placement="right" width="400" trigger="click">
							<div class="role-radio"><el-radio-group v-model="radio" @change="changeRole()">
									<el-radio :label="2">组织委员</el-radio>
									<el-radio :label="3">发展对象</el-radio>
									<el-button size="mini" round @click="myaddRole(scope.row.userId)">确认</el-button>
								</el-radio-group></div>
							<el-button slot="reference" icon="el-icon-edit" circle></el-button>
						</el-popover>
					</el-tooltip>
					<el-tooltip content="删除角色" placement="top" popper-class="tooltip">
						<el-popconfirm @confirm="mydeleteUser(scope.row.userId)" title="确定要删除该用户信息吗？">
							<el-button slot="reference" icon="el-icon-delete" circle></el-button>
						</el-popconfirm>
					</el-tooltip>
					<el-tooltip content="重置密码" placement="top" popper-class="tooltip">
						<el-popconfirm @confirm="mychangePasswd(scope.row.userId)" title="确定重置该用户的密码吗？">
							<el-button slot="reference" icon="el-icon-key" circle></el-button>
						</el-popconfirm>
					</el-tooltip>
				</template>
			</el-table-column>
			<el-table-column label="角色" width="350px">
				<span slot-scope="scope">
					<el-tag effect="plain" type="info" v-for="item in scope.row.roles"
						@click="clickTag(scope.row.userId, item.role)" :key=item.role>{{ item.role }}</el-tag>
				</span>
			</el-table-column>
			<el-table-column prop="username" label="学号/工号" width="150px">
			</el-table-column>
			<el-table-column prop="fullName" label="姓名" width="100px">
			</el-table-column>
			<el-table-column prop="sex" label="性别" width="100px">
			</el-table-column>
			<el-table-column prop="minzu" label="民族" width="120x">
			</el-table-column>
			<el-table-column prop="mobile" label="手机号码" width="120x">
			</el-table-column>
			<el-table-column prop="banji" label="班级" width="120x">
			</el-table-column>
			<el-table-column prop="jiguan" label="籍贯" width="120x">
			</el-table-column>
			<el-table-column prop="hujidizhi" label="户籍地址" width="120x">
			</el-table-column>
			<el-table-column prop="juzhudizhi" label="居住地址" width="120x">
			</el-table-column>
			<el-table-column prop="birth" label="出生日期" width="120x">
			</el-table-column>
			<el-table-column prop="identity" label="证件号" width="220x">
			</el-table-column>
		</el-table>
		<!--分页区域-->
		<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
			:current-page="queryInfo.pageNo" :page-sizes="[5, 10, 30, 50]" :page-size="queryInfo.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total=count>
		</el-pagination>
	</div>
</template>

<script>
import { getUserList, deleteUser, addRole, deleRole,updateUser } from "@/utils/api.js"

export default {
	data() {
		return {
			count: 10,
			//角色单选框
			radio: [],
			userList: [],
			roleInfo: {
				userId: '',
				role: ''
			},
			passwd:{
				userId: '',
				password: ''
			},
			queryInfo: {
				fullName: '',
				pageSize: 30,
				pageNumber: 1,
			},
			remorveRole: {
				userId: '',
				role: ''
			},
			title: '党建平台用户信息',
			json_fields: {
				'学号': 'username',
				'姓名': 'fullName',
				'班级': 'banji',
				'出生日期': 'birth',
				'性别': 'sex',
				'民族': 'minzu',
				'籍贯': 'jiguan',
				'手机号码': 'mobile',
				'身份证号码': {
					field: "identity",
					callback: value => {
						return "&nbsp;" + value;
					}
				},
				'户籍地址': 'hujidizhi',
				'居住地址': 'juzhudizhi',

			},

		}
	},
	created() {
		this.mygetUserList();
	},
	methods: {
		mygetUserList() {
			getUserList(this.queryInfo).then(result => {
				if (result.code === '0000') {
					this.userList = result.data[0];
					this.count = result.data[1][0];
				} else {
					console.log(result)
				}
			})
		},
		mydeleteUser(id) {
			const param = { "userId": id }
			deleteUser(param).then(result => {

				if (result.code === '0000') {
					this.$message.success(result.message);
					this.mygetUserList();
				} else {
					console.log(result)
				}
			})
		},
		myaddRole(id) {
			this.roleInfo.userId = id;
			addRole(this.roleInfo).then(result => {
				if (result.code === '0000') {
					this.$message.success(result.message);

					this.mygetUserList();
					this.doClose();
				} else {
					console.log(result);
					this.doClose();
				}
			})
		},

		mychangePasswd(id){
			this.passwd.userId = id;
            this.passwd.password='123456';
			updateUser(this.passwd).then(result => {
				if (result.code === '0000') {
					this.$message.success(result.message);

				} else {
					console.log(result);
				}
			})


		},

		doClose() {
			this.userList.forEach((ele, index) => {
				this.$refs[`popover-${index}`].doClose()
			})
		},
		changeRole() {
			if (this.radio == '1') {
				this.roleInfo.role = '党员联系老师';
			} else if (this.radio == '2') {
				this.roleInfo.role = '组织委员';
			} else if (this.radio == '3') {
				this.roleInfo.role = '入党积极分子';
			}
		},
		clickTag(id, tag) {
			this.remorveRole.userId = id;
			this.remorveRole.role = tag;

			console.log(tag);
			this.$confirm('此操作将删除该角色, 是否继续?', '角色删除', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				deleRole(this.remorveRole).then(result => {
					if (result.code === '0000') {

						this.mygetUserList();
					} else {
						console.log(result);
					}
				})
				this.$message({
					type: 'success',
					message: '删除成功!'
				});
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		//监听PageSize的长度
		handleSizeChange(newSize) {
			this.queryInfo.pageSize = newSize;
			this.mygetUserList();

		},
		//监听页码值改变的事件
		handleCurrentChange(newPage) {
			this.queryInfo.pageNumber = newPage;
			this.mygetUserList();
			this.queryInfo.pageNumber = 1;
		
		},
	}
}
</script>

<style >
.title {
	font-size: 20px;
}

.basicInfo {
	height: 300px;
	width: 500px;
	background-color: bisque;
}

.container .el-pagination button:hover {
	color: rgb(227, 122, 122);
}

.container .el-pagination li.number.active {
	background: rgb(229, 139, 139) !important;
}

.container .el-pagination .el-select .el-input .el-input__inner {
	color: #000 !important;
	border-color: rgb(229, 139, 139);
	background-color: #fff;
}

.role-radio .el-button .el-button--default .el-button--mini .is-round {
	background-color: #e43f3e;
}

/* 修改提示框的内容背景色 */
.tooltip {
	background: #e43f3e !important;
	height: 30px;
	font: 20px;

}

.tooltip .el-tooltip__popper[x-placement^=top] .popper__arrow::after {
	border-left-color: #e43f3e !important;
}

.tooltip .el-tooltip__popper[x-placement^=top] .popper__arrow {

	border-left-color: #e43f3e !important;
}


.myRow .el-button--primary:focus,
.myRow .el-button--primary:hover {
	background-color: #fff;
	color: #e43f3e;
	border-radius: 18px !important;
	width: 130px;
	font-size: 18px;
	border-color: #e43f3e;
}

.myRow .el-button--primary {
	background: #e43f3e;
	border-color: #e43f3e;
	color: #fff;
	border-radius: 18px !important;
	font-size: 18px;
}

.el-popover {
	padding: 10px !important;
	font-size: 18px !important;
	border: 1px solid gray !important;
	background-color: #f4eded !important;
	height: 30px;
}

.el-upload {
	width: 100%;
}

.el-upload .el-upload-dragger {
	width: 100%;
}

.el-breadcrumb .el-breadcrumb__inner {
	color: grey;
	font-size: 18px;
}

.myRow {
	margin-top: 50px;
	margin-bottom: 30px;
	margin-left: 20px;
	font-size: 18px;
	font-weight: 500;
	color: #696767;
}

.el-tag+.el-tag {
	margin-left: 10px;
}
</style>